import React from 'react';
import axios from 'axios';
import {
    BASE_DONNEE_TECHNIQUE,
    GET_COMMUNES,
    GET_EXPLOITATIONS,
    GET_QUARTIERS,
    GET_RUES,
} from "../../api/Api";

export default function useDonneeTechniqueData(type,filter){

    const [isLoading,setIsLoading] = React.useState(false);
    const [datas,setDatas] = React.useState([]);

    React.useEffect(
        () => {

            setIsLoading(true)

            axios
                .get(
                    BASE_DONNEE_TECHNIQUE,
                    {
                        params: {
                            all: 'true',
                            type: type
                        }
                    }
                ).then(
                ({data}) => {

                     setDatas(data);
                     console.log('datas',data)

                }
            ).finally(
                ()=>{
                    setIsLoading(false);
                }
            )

        }, []
    );

    return [isLoading,datas]
}